export default __webpack_public_path__ + "static/media/ProfitEstimations-landing.5b64a2a9.png";